module.exports = __webpack_public_path__ + "a1f264bbe9ccede4e30724e3184142d5.svg";